import { Icon, ToggleButton } from '@mui/material';
import { FC } from 'react';
import { CfDataGridDisplayMode } from '../../CfDataGridProps';
import { StyledToggleButtonGroup } from './CfDataGridDisplayModeToggle.styles';

interface CfDataGridDisplayModeToggleProps {
  displayMode: CfDataGridDisplayMode;
  onChange: (value: CfDataGridDisplayMode) => void;
}
export const CfDataGridDisplayModeToggle: FC<CfDataGridDisplayModeToggleProps> = (
  props: CfDataGridDisplayModeToggleProps
) => {
  return (
    <StyledToggleButtonGroup
      sx={{
        '& .MuiButtonBase-root': {
          height: (theme) => ({ xs: theme.spacing(4), xl: theme.spacing(3) }),
          width: (theme) => ({ xs: theme.spacing(4.5), xl: theme.spacing(3.5) }),
        },
      }}
      exclusive
      value={props.displayMode}
      onChange={(event, value) => value && props.onChange(value)}
    >
      <ToggleButton value='card' size='small' disabled={props.displayMode === 'card'}>
        <Icon className='fa-th-large' fontSize='medium' />
      </ToggleButton>
      <ToggleButton value='table' size='small' disabled={props.displayMode === 'table'}>
        <Icon className='fa-list' fontSize='medium' />
      </ToggleButton>
    </StyledToggleButtonGroup>
  );
};
